import {
  AuthenticationResult,
  Configuration,
  PublicClientApplication,
  RedirectRequest,
} from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID ?? '',
    authority:
      process.env.REACT_APP_ENTRA_AUTHORITY ??
      'https://login.microsoftonline.com/organizations',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const entraLoginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
  prompt: 'select_account',
};

export const msalInstance = new PublicClientApplication(msalConfig);

let redirectPromise: Promise<AuthenticationResult | null> | undefined;

// handleRedirectPromise must only be processed once per page load, and the
// result must only be handed out once so a remounted login page (e.g. after
// logout) does not replay the old token.
export const handleEntraRedirect = (): Promise<AuthenticationResult | null> => {
  if (!redirectPromise) {
    const pending = msalInstance.handleRedirectPromise();
    redirectPromise = pending.then(
      () => null,
      () => null,
    );
    return pending;
  }
  return redirectPromise;
};

export const isEntraSignedIn = (): boolean =>
  msalInstance.getAllAccounts().length > 0;

export const clearEntraSession = async (): Promise<void> => {
  const account = msalInstance.getAllAccounts()[0];
  if (!account) {
    return;
  }
  await msalInstance.logoutRedirect({
    account,
    postLogoutRedirectUri: window.location.origin,
  });
};
